const Footer = () => {
  return (
    <footer className="bg-blue-900 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="mb-4 bg-white p-3 rounded-lg inline-block shadow-md">
              <img 
                src="https://customer-assets.emergentagent.com/job_biz-builder-10/artifacts/6xvcab3i_DeepCoreLearningLabLogo.png?v=4" 
                alt="DeepCore Learning Lab" 
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-blue-200 text-sm">
              Empowering learners with AI-driven education and professional certifications.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-blue-200 text-sm">
              <li><a href="#home" className="hover:text-amber-400 transition-colors">Home</a></li>
              <li><a href="#services" className="hover:text-amber-400 transition-colors">Services</a></li>
              <li><a href="#products" className="hover:text-amber-400 transition-colors">Products</a></li>
              <li><a href="#contact" className="hover:text-amber-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-blue-200 text-sm">
              <li>DeepCore Trading, Training & Consultancy LLC</li>
              <li>DBA: DeepCore Learning Lab</li>
              <li>Registered in Virginia</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-blue-800 pt-8 text-center text-blue-200 text-sm">
          <p>&copy; {new Date().getFullYear()} DeepCore Learning Lab. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;